import { Route, Routes } from "react-router-dom";
import GeneralReview from "./GeneralReview";
import ReviewPopupTimeInfoArea from "./ReviewPopupTimeInfoArea";
import ReviewTopNav from "./ReviewTopNav";
import SpecialReview from "./SpecialReview";
import AppBar2 from "../../appbar/AppBar2";
import ReviewSetting from "./ReviewSetting";
import ReviewAnalytics from "./ReviewAnalytics";
const Review = function () {
  return (
    <div>
      <ReviewTopNav />
      <ReviewPopupTimeInfoArea />
      <Routes>
        <Route path="/" element={<GeneralReview />} />
        <Route path="/special" element={<SpecialReview />} />
        <Route path="/setting" element={<ReviewSetting />} />
        <Route path="/analytics" element={<ReviewAnalytics />} />
        
        {/* <Route path="/All-Projects" element={<AllProjects />} />
            <Route path="*" element={<NotFound />} /> */}
      </Routes>
    </div>
  );
};
export default Review;
